import { makeStyles, DefaultTheme } from '@material-ui/styles';
import cn from 'clsx';
import Text from '../../Text';
import { IndeterminateCircle, CheckboxBlankCircleLine } from '../../icons';
import BaseButton from '../BaseButton';

export interface CheckAllButtonProps extends React.ComponentProps<typeof BaseButton> {
    checked: boolean;
    checkAllText?: string;
    uncheckAllText?: string;
}
const CheckAllButton: React.FC<CheckAllButtonProps> = ({
    checked,
    checkAllText = 'Check all',
    uncheckAllText = 'Uncheck all',
    className,
    ...baseButtonProps
}) => {
    const classes = useStyles();
    return (
        <BaseButton {...baseButtonProps} className={cn(className, classes.root)}>
            {checked ? (
                <IndeterminateCircle className={classes.icon} />
            ) : (
                <CheckboxBlankCircleLine className={classes.icon} />
            )}
            <Text variant="t81" className={classes.text}>
                {checked ? uncheckAllText : checkAllText}
            </Text>
        </BaseButton>
    );
};

const useStyles = makeStyles<DefaultTheme>(
    theme => ({
        root: {
            display: 'flex',
            alignItems: 'center',
        },
        icon: {
            width: 20,
            height: 20,
            marginRight: 6,
            color: theme.palette.greys[500],
        },
        text: {
            color: theme.palette.greys[500],
        },
    }),
    { classNamePrefix: 'check-all-button' }
);

export default CheckAllButton;
